'use client'

import { createBrowserClient } from '@supabase/ssr'
import { Database } from '@/types/supabase'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

export const isSupabaseEnvConfigured = Boolean(supabaseUrl && supabaseKey)

/**
 * 브라우저 클라이언트 생성
 * 클라이언트 컴포넌트에서만 사용
 * 
 * Supabase가 자동으로 쿠키를 관리하므로 별도 옵션 없이 기본 설정 사용
 */
export const createClient = (): any => {
  if (typeof window === 'undefined') {
    throw new Error('createClient는 클라이언트에서만 사용할 수 있습니다.')
  }

  if (!supabaseUrl || !supabaseKey) {
    throw new Error('NEXT_PUBLIC_SUPABASE_URL과 NEXT_PUBLIC_SUPABASE_ANON_KEY가 설정되어야 합니다.')
  }

  // ✅ 간단하게: Supabase가 자동으로 쿠키를 관리하도록 기본 설정 사용
  return createBrowserClient<Database>(supabaseUrl, supabaseKey) as any
}

// 하위 호환성을 위한 export
export const createSupabaseBrowserClient = createClient
